// extracted by mini-css-extract-plugin
module.exports =  {"tag":"kEGkNqw","interactive":"u66agdQ","size-sm":"Fytjryy","sizeSm":"Fytjryy","variant-outline":"DCBvUVo","variantOutline":"DCBvUVo"};